import type { SportsbookBetslipCapabilities } from "../contract";

const SPORT_ID_FOOTBALL = 1;
const SPORT_ID_HORSE_RACING = 7;

const DEFAULT_SPORTSBOOK_CAPABILITIES: SportsbookBetslipCapabilities = {
  trapIcon: { enabled: false },
  selectionTypeIcon: { enabled: false },
  acceptOddsMovementAlert: { enabled: false },
  receiptPushNotifications: {
    enabled: true,
    supportedSportIds: [SPORT_ID_FOOTBALL, SPORT_ID_HORSE_RACING],
    unsupportedEventIds: [],
  },
  priceBoostSignposting: { enabled: false },
  stakeInputCaret: { enabled: false },
  upsellSuggestions: { enabled: false },
  upsellReceiptSuggestions: { enabled: false, exposure: null },
  stakeAutoFocus: { enabled: false },
  multiBetBuilderOnboarding: { enabled: false },
  betConfirmationStep: { enabled: false },
  depositPrompt: { enabled: false },
  marketAvailabilityGuidance: { enabled: false },
  oddsChangeNotification: { enabled: true },
  receiptTopContentPlacement: { enabled: false },
  withAllPebble: { enabled: false },
  bestOddsGuaranteedLabel: { enabled: true },
  skipDirtyCheck: { enabled: false },
  dailyPayoutLimit: { enabled: false },
  placeFailurePriceInferral: { enabled: false },
  minimiseBetslip: { enabled: false },
  quickBetslip: { enabled: false },
  singlesOnTop: { enabled: false },
  catalogueFetching: { enabled: false },
  selectionConnector: { enabled: false },
};

export const resolveSportsbookCapabilities = (
  overrides: Partial<SportsbookBetslipCapabilities> = {},
): SportsbookBetslipCapabilities => ({ ...DEFAULT_SPORTSBOOK_CAPABILITIES, ...overrides });
